import { useEffect } from 'react'

import { store } from '../stores'
import { loadRevenueCenters } from '../actions/revenueCenter'
import { fetchEmployeeRoles } from '../actions/employeeRole'

const useDispatchInitialActions = () => {
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken')

    if (!!accessToken) {
      store.dispatch(loadRevenueCenters())
      store.dispatch(fetchEmployeeRoles())
    }
  }, [])
}

export default useDispatchInitialActions
